/* WorkTriggerScheduleTabRenderer.js */

"use strict";
const ScheduleComponent = require("@gluenetworks/schedule_component");

class WorkTriggerScheduleTabRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("worktrig-schedule-view-tab-gl");
        this._rootElem.component = this._model;
        this._scheduleComponent = new ScheduleComponent(this._model.getSchedule());
        this._scheduleComponent.theme = "light";
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        return this._scheduleComponent
            .shutdown()
            .then(() => {
                this._unregisterListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._scheduleComponent = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        this._model.on("Shutdown", this._onShutdown.bind(this));
        this._scheduleComponent.on("UserValue", (this._onScheduleChange = this._onScheduleChange.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._scheduleComponent.removeListener("UserValue", this._onScheduleChange);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this._rootElem.hasChildNodes()) {
            return Promise.resolve();
        }
        return this._scheduleComponent.renderer.render().then(() => {
            this._rootElem.appendChild(this._scheduleComponent.renderer.rootElement);
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onScheduleChange(s) {
        this._model.setSchedule(s);
    }
    _onShutdown() {
        this._shutdown();
    }
}
module.exports = WorkTriggerScheduleTabRenderer;
